import { Badge } from '@chakra-ui/react';

type BatchStatus =
  | 'successful'
  | 'failed'
  | 'processing'
  | 'updating'
  | 'validating'
  | 'scheduled'
  | 'cancelled'
  | 'completedWithErrors';

interface StatusConfig {
  label: string;
  color: string;
  backgroundColor: string;
}

interface BatchesStatusProps {
  status: BatchStatus | string;
}

const BatchesStatus = ({ status }: BatchesStatusProps) => {
  const batchesStatusConfig: Record<BatchStatus, StatusConfig> = {
    successful: {
      label: 'Successful',
      color: '#339900',
      backgroundColor: '#99cc3380',
    },
    failed: {
      label: 'Failed',
      color: '#E30000',
      backgroundColor: '#FF565380',
    },
    completedWithErrors: {
      label: 'Completed with Errors',
      color: '#D56700',
      backgroundColor: '#fc860080',
    },
    processing: {
      label: 'Processing',
      color: '#B08D00',
      backgroundColor: '#FFCC0080',
    },
    updating: {
      label: 'Updating',
      color: '#B08D00',
      backgroundColor: '#FFCC0080',
    },
    validating: {
      label: 'Validating',
      color: '#B08D00',
      backgroundColor: '#FFCC0080',
    },
    scheduled: {
      label: 'Scheduled',
      color: '#0400D8',
      backgroundColor: '#4b6ef580',
    },
    cancelled: {
      label: 'Cancelled',
      color: '#6C6C6C',
      backgroundColor: '#c9c9c980',
    },
  };

  const current: StatusConfig = batchesStatusConfig[
    String(status) as BatchStatus
  ] || {
    label: 'Unknown',
    color: 'gray',
    backgroundColor: 'transparent',
  };

  return (
    <Badge bg={current.backgroundColor} color={current.color} fontWeight="bold">
      {current.label}
    </Badge>
  );
};

export default BatchesStatus;
